import tw from 'twin.macro'
import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { Handle, Position } from '@xyflow/react'
import { IoIosCloseCircle } from 'react-icons/io'

import { useUpdateQuizDraftMutation } from '../appOnboardingQuizApi'

import { availableItemTypes } from 'common/components/AddItemButton/constants/constants'
import { Dialog, DialogContent, DialogTrigger } from 'common/components/Dialog/Dialog'
import { DeleteDialogBanner } from 'common/components/DeleteDialogBanner/DeleteDialogBanner'

import WorkoutResult from './WorkoutResult'
import VideoResult from './VideoResult'
import ProgramResult from './ProgramResult'

import { setLastSelectedNodeId, setSelectedNodeId } from '../quizFlowSlice'

const ResultNode = memo(({ id, data, selected }) => {
  const dispatch = useDispatch()

  const [updateQuizDraft] = useUpdateQuizDraftMutation()

  const handleRemove = () => {
    updateQuizDraft({
      coachOrgId: data?.coachOrgId,
      questions: {
        [`${data?.parentQuestionId}/answers/${id}`]: {
          index: data?.index,
          title: data?.title || null,
          description: data?.description || null,
          result: null,
          resultId: null,
          nextQuestionId: id,
        },
        [id]: {
          id,
          previousQuestionId: data?.parentQuestionId,
        },
      },
      results: {
        [`${data?.result?.id}/${data?.parentQuestionId}/${id}`]: null,
      },
    })
  }

  return (
    <div
      className='relative group flex items-center w-96 rounded-md border border-gray-300 bg-white p-2'
      css={[
        data?.wasSelected && tw`border-black border-2`,
        selected && tw`border-tGreen`,
        data?.markedForDelete && tw`border-red-500 border-2`,
      ]}
    >
      <Handle type='target' position={Position.Left} isConnectable={false} />
      <Result coachOrgId={data?.coachOrgId} item={data.result} selected={selected} />
      <Dialog>
        <DialogTrigger
          onOpenCb={(e) => {
            e.stopPropagation()
            dispatch(setLastSelectedNodeId(id))
          }}
          className='group-hover:visible hover:visible invisible absolute -top-2.5 -right-2.5 text-gray-500 hover:text-gray-600 bg-white transition-colors z-20 nodrag nopan'
        >
          <IoIosCloseCircle className='cursor-pointer w-5 h-5' />
        </DialogTrigger>
        <DialogContent
          dialogCloseCb={(e) => {
            e.stopPropagation()
            dispatch(setLastSelectedNodeId(id))
          }}
        >
          <DeleteDialogBanner
            text='This will remove the result.'
            handleDelete={() => {
              handleRemove()
              dispatch(setSelectedNodeId(id))
            }}
            deleteText='Remove'
          />
        </DialogContent>
      </Dialog>
    </div>
  )
})

export default ResultNode

function Result({ coachOrgId, item, selected }) {
  if (item.type === availableItemTypes.VIDEO) {
    return <VideoResult coachOrgId={coachOrgId} item={item} selected={selected} />
  }

  if (item.type === availableItemTypes.WORKOUT) {
    return <WorkoutResult coachOrgId={coachOrgId} item={item} selected={selected} />
  }

  if (item.type === availableItemTypes.PROGRAM) {
    return <ProgramResult item={item} selected={selected} />
  }

  return null
}
